import React from 'react';

/* eslint-disable */
class Gallery extends React.Component {
	render() {
		const { images = [] } = this.props;
		return (
			<div className="main-content-body-inner-container">
				<div className="main-content-body-title">
					GALLERY
				</div>
       			<div className="main-content-gallery-container main-content-body-scrollable-box">
					{images.map(img => (
						<div
							key={img.id}
							className="gallery-image-box"
							style={{ backgroundImage: `url(${img.src})` }}
						/>
					))}
        		</div>
			</div>
		);
	}
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/Theme/Gallery.jsx